import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export const Paper = ({ children, bgColor }: PropsWithChildren<{ bgColor?: string }>) => {
  return <Box
    bgColor={bgColor || 'white'}
    boxShadow='sm'
    borderRadius='md'
  >{children}</Box>;
};